// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from './assets/js/https'
import axios from 'axios'
import store from './vuex/store'
import httpConfig from '../static/httpConfig'
import Antd from 'ant-design-vue'

import "@/assets/css/reset.css";
import "@/assets/css/base.css";
import "@/assets/css/public.css";
import 'ant-design-vue/dist/antd.css'



Vue.use(Antd)
Vue.prototype.$http = http
Vue.prototype.$axios = axios




Vue.prototype.$httpConfig = httpConfig
Vue.config.productionTip = false
Vue.prototype.$store = store

window.Date.prototype.Format = function (fmt) { //author: meizz
  function getWeek(num) {
    if (num == 0) return '日'
    if (num == 1) return '一'
    if (num == 2) return '二'
    if (num == 3) return '三'
    if (num == 4) return '四'
    if (num == 5) return '五'
    if (num == 6) return '六'


  }
  let o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds(), //毫秒
    "w": getWeek(this.getDay()) //毫秒
  };

  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  created: function () {
    if (!window.location.href.includes('transfer')) {
      this.$router.push('/index')
    }
  },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js